import request from "src/utils/request";
import useApi from "src/utils/api/use-api";
import { sleep } from "src/utils/api/mock-utils";
import { useAuth } from "src/components/providers/auth-context";

const useTeamApi = (teamId) => {
    if (!teamId) return {};
    const { user, userHasTeamsSubscription } = useAuth();
    const getMockData = async () => {
        await sleep();
        return {
            id: "0ca162de-d14f-419c-a350-d3d9a40159aa",
            name: "Eagle's Fang",
            picture: "",
            description: "Procrastination Experts",
            creator: {
                id: "b2595224-51c3-4e67-8184-eeb96aa59cb1",
                displayName: "Orfeus Panagathos",
                picture: "",
                jobTitle: "Grandmaster Developer",
            },
            owner: {
                id: "6d737aa5-b8a5-464a-8e93-215f65d3b02a",
                displayName: "Laurel Halo",
                jobTitle: "Grandmaster Developer",
                email: "l.halo@adadot.com",
            },
            membersCount: 7,
            members: [
                {
                    id: "b2595224-51c3-4e67-8184-eeb96aa59cb1",
                    displayName: "Orfeus Panagathos",
                    jobTitle: "Grandmaster Developer",
                    picture:
                        "https://assets-sit.adadot.com/b2595224-51c3-4e67-8184-eeb96aa59cb1.png",
                    email: "o.panagathos@adadot.com",
                    isOwner: false,
                    isProfilePublic: true,
                    isIntegrated: {
                        slack: true,
                        github: false,
                        gitlab: true,
                        gitlabSelfManaged: false,
                        jira: false,
                    },
                },
                {
                    id: "6d737aa5-b8a5-464a-8e93-215f65d3b02a",
                    displayName: "Laurel Halo",
                    jobTitle: "Grandmaster Developer",
                    picture:
                        "https://assets-sit.adadot.com/6d737aa5-b8a5-464a-8e93-215f65d3b02a.png",
                    email: "l.halo@adadot.com",
                    isOwner: true,
                    isIntegrated: {
                        slack: false,
                        github: false,
                        gitlab: false,
                        gitlabSelfManaged: false,
                        jira: false,
                    },
                },
                {
                    id: "bc9af2b7-f342-4878-bace-6be7164604f1",
                    displayName: "Wang Harrison",
                    jobTitle: "Fullstack Developer",
                    picture:
                        "https://assets-sit.adadot.com/bc9af2b7-f342-4878-bace-6be7164604f1.png",
                    email: "w.harrison@adadot.com",
                    isOwner: false,
                    isIntegrated: {
                        slack: true,
                        github: false,
                        gitlab: true,
                        gitlabSelfManaged: false,
                        jira: false,
                    },
                },
                {
                    id: "60c22d90-a686-43f9-b715-33e77f6226db",
                    displayName: "Stacey Hobgoblens",
                    jobTitle: "Frontend Developer",
                    picture:
                        "https://assets-sit.adadot.com/60c22d90-a686-43f9-b715-33e77f6226db.png",
                    email: "s.hobgoblens@adadot.com",
                    isOwner: false,
                    isIntegrated: {
                        slack: true,
                        github: false,
                        gitlab: true,
                        gitlabSelfManaged: false,
                        jira: false,
                    },
                },
                {
                    id: "72ec4dfe-d9c5-4da1-9fe9-7697165c0640",
                    displayName: "Ibi Jetson",
                    jobTitle: "Decent Developer",
                    picture:
                        "https://assets-sit.adadot.com/72ec4dfe-d9c5-4da1-9fe9-7697165c0640.png",
                    email: "i.jetson@adadot.com",
                    isOwner: false,
                    isIntegrated: {
                        slack: true,
                        github: false,
                        gitlab: true,
                        gitlabSelfManaged: true,
                        jira: false,
                    },
                },
                {
                    id: "c4d21b4f-bd52-42a9-82b9-25e5c6a14933",
                    displayName: "Natasha Green",
                    jobTitle: "Data Scientist",
                    picture:
                        "https://assets-sit.adadot.com/c4d21b4f-bd52-42a9-82b9-25e5c6a14933.png",
                    email: "n.green@adadot.com",
                    isOwner: false,
                    isIntegrated: {
                        slack: false,
                        github: false,
                        gitlab: true,
                        gitlabSelfManaged: false,
                        jira: true,
                    },
                },
                {
                    id: "1e9f02a8-cf1a-40c9-8d70-8f4e6452c2a4",
                    displayName: "Larry Lalonde",
                    jobTitle: "Frontend Monkey",
                    picture:
                        "https://assets-sit.adadot.com/1e9f02a8-cf1a-40c9-8d70-8f4e6452c2a4.png",
                    email: "l.lalonde@adadot.com",
                    isOwner: false,
                    isIntegrated: {
                        slack: true,
                        github: false,
                        gitlab: true,
                        gitlabSelfManaged: true,
                        jira: false,
                    },
                },
                {
                    id: user.id,
                    displayName: user.displayName,
                    jobTitle: user.jobTitle,
                    picture: user.picture,
                    email: user.email,
                    isOwner: false,
                    isIntegrated: {
                        slack: true,
                        github: false,
                        gitlab: true,
                        gitlabSelfManaged: true,
                        jira: true,
                    },
                },
            ],
            tempMembers: [
                {
                    id: "b2595224-51c3-4e67-8184-eeb96aa59cb1",
                    displayName: "Orfeus Panagathos",
                    jobTitle: "Grandmaster Developer",
                    picture:
                        "https://assets-sit.adadot.com/b2595224-51c3-4e67-8184-eeb96aa59cb1.png",
                    email: "o.panagathos@adadot.com",
                    isOwner: false,
                    isProfilePublic: true,
                    isIntegrated: {
                        slack: true,
                        github: false,
                        gitlab: true,
                        gitlabSelfManaged: false,
                        jira: false,
                    },
                },
                {
                    id: "6d737aa5-b8a5-464a-8e93-215f65d3b02a",
                    displayName: "Laurel Halo",
                    jobTitle: "Grandmaster Developer",
                    picture:
                        "https://assets-sit.adadot.com/6d737aa5-b8a5-464a-8e93-215f65d3b02a.png",
                    email: "l.halo@adadot.com",
                    isOwner: true,
                    isIntegrated: {
                        slack: false,
                        github: false,
                        gitlab: false,
                        gitlabSelfManaged: false,
                        jira: false,
                    },
                },
            ],
            isPublic: true,
        };
    };
    if (!userHasTeamsSubscription) return useApi(() => getMockData());
    return useApi(() => request(`/api/teams/${teamId}`));
};

export default useTeamApi;
